/**
 * Single source of truth for the subscription-status pill that appears in
 * the header user menu, the subscription management dialog, and any future
 * surfaces that need to communicate plan state.
 *
 * Keeping shape (rounded-full, border, typography, padding) identical and
 * tone (color) the only variable means the badges read as one component
 * across the product instead of three slightly-different ones.
 */
export type SubBadgeTone =
  | "active"
  | "expiring"
  | "expired"
  | "canceled"
  | "past_due"
  | "none";

export const SUB_BADGE_BASE =
  "inline-flex items-center rounded-full border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider";

export const SUB_BADGE_TONES: Record<SubBadgeTone, string> = {
  // Healthy / current → emerald
  active:   "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  // Soft warning → amber (expiring soon, manual cancel scheduled)
  expiring: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  canceled: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  // Hard failure / lapsed → semantic destructive token
  expired:  "bg-destructive/15 text-destructive border-destructive/30",
  past_due: "bg-destructive/15 text-destructive border-destructive/30",
  // Neutral / no plan → muted
  none:     "bg-muted text-muted-foreground border-border",
};

export const subscriptionBadgeClass = (tone: SubBadgeTone) =>
  `${SUB_BADGE_BASE} ${SUB_BADGE_TONES[tone]}`;
